<template>
  <div class="pre-complete-modal text-center" :class="{ 'second': preCompleteModalShow === 2 }">
    <span class="warning-icon">
      <img src="/img/warning.png" alt="warning">
    </span>

    <template v-if="preCompleteModalShow === 1">
      <h2>Please notice</h2>
      <p>
        You <strong>have NOT</strong> sent any sneak peek or arranged a call to the customer.
      </p>
      <p>
        Are you sure you want to complete and send the box to the customer now?
      </p>
      <div class="buttons flex justify-content-around margin-top">
        <button class="bg-dark-blue flex margin-auto" @click="$emit('close')">
          <SvgFile name="back" color="#fff" size="12" />
          <span class="small-margin-left">Go Back</span>
        </button>
        <button class="bg-sunset-orange" @click="switchToReason">Complete</button>
      </div>
    </template>
    <template v-if="preCompleteModalShow === 2">
      <p class="text-left">
        Comment why you don't want to send a Sneak Peek for this styling:
      </p>
      <textarea class="full-width rounded" placeholder="Comment here..." rows="6" v-model="reason"></textarea>
      <div class="text-left error" v-if="reason && reason.length < 25">Minimum 25 characters</div>
      <div class="buttons margin-top">
        <button class="bg-sunset-orange" :disabled="reason.length < 25" @click="sendReason">Send</button>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import Product from './Product.vue'

let loader

export default {
  name: 'PreCompleteModal',
  data () {
    return {
      preCompleteModalShow: 1,
      reason: ''
    }
  },
  methods: {
    switchToReason () {
      setTimeout(() => {
        this.preCompleteModalShow = 2
      }, 100)
    },
    sendReason () {
      if (this.reason && this.reason.length >= 25) {
        Vue.api.post(`/order/${this.$route.query.id}/styling/finish/reason`, {
          reason: this.reason
        }, {
          before: () => loader = this.$loading.show(),
          always: () => loader.hide(),
          callback: () => this.$emit('complete', false)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pre-complete-modal {
  &.second {
    margin-right: -20px;
    margin-left: -20px;
  }

  .warning-icon {
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    padding: 10px;
    border-radius: 50%;
    background: #F2F2F2;
    line-height: 60px;
    border: 2px solid #FFF;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .buttons {
    button {
      border-radius: 6px;
      box-shadow: 0px 3px 6px 0px rgba(0,0,0,.2);
    }
  }
}
</style>
